import React from "react";
import {
  Card
} from "shards-react";
import '../../styles/devices.min.css';

const AppScreen = ({ info }) => (
 
    
    <div style={{margin:'-10px 0px 10px 0',height:'50vh',width:'70%'}}  className="marvel-device iphone5s gold">
    <div className="top-bar"></div>
    <div className="sleep"></div>
    <div className="volume"></div>
    <div className="camera"></div>
    <div className="sensor"></div>
    <div className="speaker"></div>
    <div className="screen">
      <div style={{backgroundColor:info.backgroundColor}}  className="appContainer">
       <img className="appLogo" src={info.logo} />
       <h2 className="appTitle">{info.appTitle}</h2>
       <p className="appSubTitle">{info.subTitle}</p>
       </div>
    </div>
    <div className="home"></div>
    <div className="bottom-bar"></div>
</div>

  
);

export default AppScreen;
